var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleTip = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _dsIcons = require("@olxbr/ds-icons");
var _dsWeb = require("@olxbr/ds-web");
var _ = require("../");
var _lurker = require("../../../helpers/lurker");
var _isMobile = require("../../../helpers/isMobile");
var _jsxRuntime = require("react/jsx-runtime");
var _this = this,
  _jsxFileName = "/Users/natalia.silva/Documents/OLX-PROJECTS/chatmod-react-components/packages/tips/src/components/RateTip/SingleTip/index.js";
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var SingleTip = function SingleTip(_ref) {
  var chatId = _ref.chatId,
    accountId = _ref.accountId,
    securityStorage = _ref.securityStorage,
    cordialityStorage = _ref.cordialityStorage,
    variant = _ref.variant,
    userName = _ref.userName,
    partnerName = _ref.partnerName;
  var _useState = (0, _react.useState)(securityStorage),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    securityRating = _useState2[0],
    setSecurityRating = _useState2[1];
  var _useState3 = (0, _react.useState)(cordialityStorage),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    cordialityRating = _useState4[0],
    setCordialityRating = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isSended = _useState6[0],
    setIsSended = _useState6[1];
  var _useState7 = (0, _react.useState)((0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {})),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    titleQuestion = _useState8[0],
    setTitleQuestion = _useState8[1];
  var isMsite = (0, _isMobile.isMobile)();
  var TextComponent = isMsite ? _dsWeb.Text.BodySmall : _dsWeb.Text.BodyMedium;
  (0, _react.useEffect)(function () {
    if (variant === 'single' && securityStorage > 0 && cordialityStorage > 0 || variant === 'v3' && cordialityStorage > 0) {
      setIsSended(true);
    }
  }, [securityStorage, cordialityStorage, variant]);
  var canSendRate = (0, _react.useMemo)(function () {
    return variant === 'single' && securityRating && cordialityRating || variant === 'v3' && cordialityRating;
  }, [securityRating, cordialityRating, variant]);
  (0, _react.useEffect)(function () {
    if (variant === 'single') {
      setTitleQuestion((0, _jsxRuntime.jsxs)(TextComponent, {
        children: [userName, ", como voc\xEA avalia o comportamento do ", partnerName, " neste chat?"]
      }));
    } else if (variant === 'v3') {
      setTitleQuestion((0, _jsxRuntime.jsxs)(TextComponent, {
        children: [userName, ", como voc\xEA avalia a ", (0, _jsxRuntime.jsx)("b", {
          children: "cordialidade"
        }), " e a ", (0, _jsxRuntime.jsx)("b", {
          children: "seguran\xE7a"
        }), " dessa conversa com o ", partnerName, "?"]
      }));
    }
  }, [variant, userName, partnerName]);
  var onChangeSecurityRating = function onChangeSecurityRating(rating) {
    setSecurityRating(rating);
  };
  var onChangeCordialityRating = function onChangeCordialityRating(rating) {
    setCordialityRating(rating);
  };
  var sendRatings = function sendRatings() {
    (0, _lurker.clickSendRating)({
      rating: securityRating,
      question: 'security',
      chat_id: chatId,
      accountId: accountId
    });
    (0, _lurker.clickSendRating)({
      rating: cordialityRating,
      question: 'cordiality',
      chat_id: chatId,
      accountId: accountId
    });
    setIsSended(true);
    (0, _.setRatingStorage)({
      securityRating: securityRating,
      cordialityRating: cordialityRating,
      chatId: chatId
    });
  };
  var buttonStyle = Object.assign({}, (isSended || !canSendRate) && {
    backgroundColor: '#cfd4dd',
    cursor: 'not-allowed'
  });
  return (0, _jsxRuntime.jsx)(_dsWeb.Flex, {
    marginTop: "--spacing-2",
    children: (0, _jsxRuntime.jsxs)(_dsWeb.Alertbox, {
      icon: (0, _jsxRuntime.jsx)(_dsIcons.ThumbsUp, {}),
      title: titleQuestion,
      children: [variant === 'v3' ? (0, _jsxRuntime.jsx)(_.RatingComponent, {
        disabled: isSended,
        initialValue: cordialityRating,
        title: "",
        onChange: onChangeCordialityRating,
        leftRating: true
      }) : (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [(0, _jsxRuntime.jsx)(_.RatingComponent, {
          disabled: isSended,
          initialValue: cordialityRating,
          title: "Cordialidade",
          onChange: onChangeCordialityRating,
          leftRating: true
        }), (0, _jsxRuntime.jsx)(_.RatingComponent, {
          disabled: isSended,
          initialValue: securityRating,
          title: "Seguran\xE7a",
          onChange: onChangeSecurityRating,
          leftRating: true
        })]
      }), isSended ? (0, _jsxRuntime.jsxs)(_dsWeb.Flex, {
        marginTop: "--spacing-2",
        alignItems: "end",
        children: [(0, _jsxRuntime.jsx)(_dsIcons.Check1Small, {
          color: "#105323"
        }), (0, _jsxRuntime.jsx)(TextComponent, {
          style: {
            color: '#105323'
          },
          children: "Agradecemos por nos ajudar :)"
        })]
      }) : (0, _jsxRuntime.jsx)(_dsWeb.Flex, {
        children: (0, _jsxRuntime.jsx)(_dsWeb.Button, {
          style: buttonStyle,
          marginTop: "--spacing-2",
          size: isMsite ? 'small' : 'medium',
          variant: "primary",
          disabled: isSended || !canSendRate,
          onClick: sendRatings,
          children: "Enviar"
        })
      })]
    })
  });
};
exports.SingleTip = SingleTip;